// Appli native des boutiques (App Store, Google Play), comme ZERO KAMI : le jeu y tourne dans Capacitor. ZERO MAZE n'est pour
// l'instant publié que sur le web ; ce test garde la règle des boutiques le jour où il le sera (pas de fonction cachée dans une appli
// d'une boutique, App Store règle 2.3.1).

/** Tourne-t-on dans une appli native (Capacitor) ? @param {Window} [win] */
export function isNativeApp(win = typeof window === 'undefined' ? undefined : window) {
  return win?.Capacitor?.isNativePlatform?.() === true;
}
